export const TOPICS = {
  JOURNEYS: 'JOURNEYS',
  OTHER_TOPIC: 'OTHER_TOPIC'
};

export const QUESTIONS_TOPICS = {
  MANAGE_ACCOUNT: 'MANAGE_ACCOUNT',
  BUGS: 'BUGS',
  BILLING: 'BILLING',
  DOCS: 'DOCS',
  OTHER_CONVERSATION: 'OTHER_CONVERSATION'
};

export const CHAT_ROUTES = {
  CLOSED: '/',
  CONVERSATIONS_LIST: '/conversations-list',
  NEW_CONVERSATION: '/new-conversation',
  TOPIC_SELECT: '/topic-select',
  JOURNEY_SELECT: '/journey-select',
  CONVERSATION: '/conversation'
};
